import styled from 'styled-components'

export const Container = styled.div`  
  display:flex;  
  width:100%;
  justify-content:center;
  align-items:center;  
  width: ${(props => props.width ? props.width : '100%')};  
  border-radius:4px;    
  ${'' /* border:solid 1px #cccccc; */}
  
  
`

export const StyledInput = styled.input`
    display:block;
    outline: none;
    background: none;
    width:100%;
    height:25px;
    border-radius:3px;
    padding:${(props => props.padding ? props.padding  : '3px')}; 
    border:none;
    background-color: #fff;  
    font-size:12px; 
    opacity: ${(props => props.opacity ? props.opacity : '1')};  

    ::-webkit-input-placeholder {
      text-align: ${(props => props.placeholderAlign ? props.placeholderAlign : 'left')};  
    }

    text-align: ${(props => props.textAlign ? props.textAlign : 'left')};

    
`